import React, { useEffect } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import useMount from '../../common/hooks/useMount';
import { fetchEventHistory, fetchLoyaltyUser } from '../../redux/actions';
import ScoreCard from '../../common/components/ScoreCard';
import PaginatedTable from '../../common/components/Table/PaginatedTable';
import Loader from '../../common/components/Loader';

const ITEMS_PER_PAGE = 10;

const mapStateToProps = (state) => ({
  eventHistory: state.usersReducer.eventHistory,
  eventHistoryOffset: state.usersReducer.eventHistoryOffset,
  eventHistoryLimit: state.usersReducer.eventHistoryLimit,
  eventHistoryTotalCount: state.usersReducer.eventHistoryTotalCount,
  isFetchingEventHistory: state.usersReducer.isFetchingEventHistory,
  isFetchingLoyaltyUserError: state.usersReducer.isFetchLoyaltyUserError,
  loyaltyUser: state.usersReducer.loyaltyUser,
  isFetchingLoyaltyUser: state.usersReducer.isFetchingLoyaltyUser,
});

const mapDispatchToProps = {
  fetchEventHistory,
  fetchLoyaltyUser,
};

export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  currentPage: (stateProps.eventHistoryOffset / stateProps.eventHistoryLimit) + 1,

  onTableChange(pagination) {
    const pageZeroBased = pagination.current - 1;

    dispatchProps.fetchEventHistory({
      userId: ownProps.userSsoId,
      limit: ITEMS_PER_PAGE,
      offset: pageZeroBased * ITEMS_PER_PAGE,
    });
  },
});

const columns = [
  {
    title: 'Event',
    dataIndex: 'event_name',
  },
  {
    title: 'Points',
    render: (record) => record.points !== undefined && record.points,
  },
  {
    title: 'Deduction/Addition',
    render: (record) => (record.points >= 0 ? 'Addition' : 'Deduction'),
  },
  {
    title: 'Time',
    dataIndex: 'created_at',
    render: (record) => moment(record).format('MM/DD/YY H:mm'),
  },
];

function EventLog(props) {
  const [mounted, setMounted] = React.useState(false);
  const [fetchedInitialData, setFetchedInitialData] = React.useState(false);

  useMount(() => {
    props.fetchLoyaltyUser({ userId: props.userSsoId });
    props.fetchEventHistory({ userId: props.userSsoId, limit: 10, offset: 0 });
    setMounted(true);
  });

  useEffect(() => {
    if (mounted && !props.isFetchingEventHistory && !props.isFetchingLoyaltyUser) {
      setFetchedInitialData(true);
    }
  }, [props.isFetchingEventHistory, props.isFetchingLoyaltyUser, mounted]);

  const score = props.isFetchingLoyaltyUserError ? '-' : get(props.loyaltyUser, 'user.pointBalance.balance', '-');

  return (
    <div>
      <Loader isLoading={!fetchedInitialData || props.isFetchingLoyaltyUser}>
        <ScoreCard score={score} text="Current Loyalty Score" />
        <PaginatedTable
          className="mt-4"
          columns={columns}
          dataSource={props.eventHistory}
          rowKey={(record) => record.event_history_id}
          loading={props.isFetchingEventHistory}
          limit={ITEMS_PER_PAGE}
          currentPage={props.currentPage}
          totalCount={props.eventHistoryTotalCount}
          // getPage is not needed. onColumnChange is enough. It's triggered when pagination or sorting is changed.
          // It should be fixed in PaginatedTable.jsx
          getPage={() => {}}
          onColumnChange={props.onTableChange}
        />
        <div className="mt-4 pt-3 bg-white d-flex justify-content-between">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link to={props.originPath}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {}}
            >
              BACK
            </button>
          </Link>

        </div>
      </Loader>
    </div>
  );
}

export { EventLog as EventLogUnconnected };

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventLog);
